import { get, isEmpty } from 'lodash';

export const formatPillarTrackerData = (points = []) => {
  const chartData = points.map(({ name, pillars = [] }) => ({
    name: +new Date(name),
    ...Object.fromEntries(pillars.map((pillar) => [pillar.name, pillar.value])),
  }));

  const startPointPillars = get(
    points.find(({ pillars }) => !isEmpty(pillars)),
    'pillars',
    [],
  );

  const lines = startPointPillars.map((pillar) => ({
    dataKey: (point) => point[pillar.name],
    name: pillar.name,
    stroke: pillar.color,
  }));

  const pointsWithPillarsCount = points.filter(({ pillars }) => !isEmpty(pillars)).length;

  return { chartData, lines, pointsWithPillarsCount };
};
